import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BottomMenuComponent } from '@app/components/layout/bottom-menu/bottom-menu.component';
import { HeaderComponent } from '@app/components/layout/header/header.component';

/**
 * Layout shell for all routes.
 * Renders mst-header (fixed top) + router-outlet + mst-bottom-menu (fixed bottom).
 */
@Component({
    selector: 'mst-layout-pages',
    template: `
        <mst-header />
        <div class="mst-layoutPages__content">
            <router-outlet />
        </div>
        <mst-bottom-menu />
    `,
    styleUrl: './layout-pages.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [HeaderComponent, RouterOutlet, BottomMenuComponent],
})
export class LayoutPagesComponent {}
